import React from 'react';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';
import { statusColor, mapStatus } from '../../invoiceStatus';
import { StyledCard, CardTitle, SaveButton, CancelButton, Spinner } from '../cardStyles';
import { InfoRow, StatusChip, DocButton, DocButtonsRow, NegadaAlert } from '../style';

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 8px;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: #0090d3;
  }
`;

interface Props {
  invoice: any;
  invoiceId: string | null;
  onEmitir: () => void;
  onCancelar: () => void;
  onExcluir?: () => void;
  onEditar?: () => void;
  onVoltar?: () => void;
  readOnly?: boolean;
}

const EmissaoSection: React.FC<Props> = ({
  invoice,
  invoiceId,
  onEmitir,
  onCancelar,
  onExcluir,
  onEditar,
  onVoltar,
  readOnly = false,
}) => {
  const c = statusColor(invoice?.status);
  const isNegada = invoice?.status === 'NEGADA';
  const isEmitindo = invoice?.status === 'EMITINDO';
  const isEmitida = invoice?.status === 'EMITIDA';
  const canEmit = !invoice?.status || invoice.status === 'RASCUNHO' || isNegada;

  return (
    <StyledCard>
      {onVoltar && (
        <BackButton onClick={onVoltar}>
          <ArrowLeft size={16} /> Voltar
        </BackButton>
      )}
      <CardTitle>Emissão</CardTitle>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        <InfoRow>
          <span style={{ color: '#666', fontSize: '13px' }}>Status</span>
          <StatusChip bg={c.bg} color={c.text}>{mapStatus(invoice?.status)}</StatusChip>
        </InfoRow>

        {isNegada && invoice?.motivoStatus && (
          <NegadaAlert>
            <span style={{ fontWeight: 700 }}>⚠</span>
            <span>{invoice.motivoStatus}</span>
          </NegadaAlert>
        )}

        {(invoice?.linkDanfe || invoice?.linkXml) && (
          <DocButtonsRow>
            {invoice?.linkDanfe && (
              <DocButton href={invoice.linkDanfe} target="_blank" rel="noreferrer">
                Ver DANFE
              </DocButton>
            )}
            {invoice?.linkXml && (
              <DocButton href={invoice.linkXml} target="_blank" rel="noreferrer">
                Baixar XML
              </DocButton>
            )}
          </DocButtonsRow>
        )}

        {!readOnly && canEmit && (
          <SaveButton onClick={onEmitir} disabled={!invoiceId} style={{ textAlign: 'center', justifyContent: 'center' }}>
            Emitir nota
          </SaveButton>
        )}
        {readOnly && canEmit && onEditar && (
          <SaveButton onClick={onEditar} style={{ textAlign: 'center', justifyContent: 'center' }}>
            Editar nota
          </SaveButton>
        )}
        {!readOnly && isEmitindo && (
          <SaveButton disabled style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <Spinner size={16} />
            Emitindo…
          </SaveButton>
        )}
        {isEmitida && (
          <CancelButton onClick={onCancelar}>Cancelar NF-e</CancelButton>
        )}
        {!readOnly && canEmit && onExcluir && (
          <CancelButton
            onClick={onExcluir}
            style={{ color: '#F75A68', borderColor: '#F75A68', background: '#fff' }}
          >
            Excluir nota
          </CancelButton>
        )}
      </div>
    </StyledCard>
  );
};

export default EmissaoSection;
